/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';

import {
  Container,
  QuestionContainer,
  Question,
  QuestionIcon,
  AnswerContainer,
  Answer,
  Separator,
} from './styles';

class Duvidas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  render() {
    const { props } = this;
    const { show } = this.state;
    return (
      <Container className="mb-3">
        <QuestionContainer
          onClick={() => this.setState({ show: !show })}
          aria-controls="example-collapse-text"
        >
          <Question>{props.question}</Question>
          <QuestionIcon className="mdi mdi-plus" />
        </QuestionContainer>
        <AnswerContainer in={show}>
          <Answer id="example-collapse-text">
            <Separator />
            {props.answer}
          </Answer>
        </AnswerContainer>
      </Container>
    );
  }
}

export default Duvidas;
